import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import PlatformStatusForm from './form'
import VendorPicker from '../../components/vendorPicker'
import Table from '../../components/MUITable'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

import IndianaScroller from 'react-indiana-drag-scroll'

const copiedFields = ["sku", "asin"]

const PlatformCostCalculations = () => {
  const [selected, setSelected] = React.useState([])
  const app = React.useContext(AppContext)  
  const { platformcostcalculations } = app.platformcostcalculations
  console.log({platformcostcalculations})
  return (
    <IndianaScroller>
      <Box padding="15px" minwidth="90vw">
        <Box padding="30px" display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%">
          <VendorPicker/>
          <PlatformStatusForm/>
        </Box>
        <Table
          onCellClick={(params, event) => {
            copiedFields.includes(params.field) && navigator.clipboard.writeText(params.value).then(() => {
              alert(`${params.field} copiado`);
            }).catch(err => {
              console.error('Failed to copy: ', err);
            });
          }}
          filterTitle="Buscar sku, asin, publicacion ..."
          model={selected}
          setmodel={setSelected}
          data={platformcostcalculations}
          getRowId={(row) => row._id}
          columns={[
            { title: "sku" , field: "sku", flex: 2},
            { title: "asin" , field: "asin", flex: 2},
            { title: "vendor" , field: "vendor", flex: 1},
            { title: "comisión" , field: "comision", flex:1 },
            { title: "envío" , field: "shipping", flex:1 },
            { title: "precip" , field: "price", flex:1 },
            { title: "moneda" , field: "currency", flex:1 },
            { title: "anchp" , field: "width", flex:1 },
            { title: "alto" , field: "height", flex:1 },
            { title: "largo" , field: "depth", flex:1 },
            { title: "peso" , field: "weight", flex:1 },
            { title: "unidad medida" , field: "unit_distance", flex:1 },
            { title: "unidad peso" , field: "unit_weight", flex:1 },
          ]}
          options={{
            selection: true,
            pageSizes:[5, 10,25,50,100,250,500]
          }}
          sx={{
            '& .MuiDataGrid-cellContent': {
            overflow: 'scroll',
            textOverflow: 'unset',
            },
            '& .MuiDataGrid-cell:hover': {
              cursor: 'pointer'
            },
          }}
        />
      </Box>
    </IndianaScroller>
  )
}
export default PlatformCostCalculations